import React from "react";
import { formatSalesValue } from "../../../utils/formatUtils";
import { SplitTotal } from "../../Bill/Table/SplitTotal";
import { adToBs } from "@sbmdkl/nepali-date-converter";
import { formatNepaliDateYear } from "../../../utils/formateDateUtils";

const calculateTotal = (list, getter) =>
    list.reduce((sum, item) => sum + Number(getter(item) || 0), 0);

const SalesVATTable = ({ order, isOrder = true }) => {
    const displayOrders = (order?.error ? [] : order || []).filter(
        (item) => item.bill_no?.trim()
    );

    return (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="max-h-[550px] overflow-auto tiny-scrollbar">
                <table className="min-w-full border-collapse text-sm text-center">
                    <thead className="sticky top-0 z-10 bg-gray-100">
                        <tr className="border-b border-gray-200">
                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Date
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Bill No
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Discount
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Sub Total
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                VAT
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Total
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Payment
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {displayOrders.length === 0 && (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="py-6 text-center text-sm text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}

                        {displayOrders.map((item, index) => (
                            <tr
                                key={index}
                                className="border-b border-gray-100 transition-colors hover:bg-gray-50"
                            >
                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {formatNepaliDateYear(adToBs(item.Date))}
                                </td>

                                <td className="whitespace-nowrap p-2 font-medium text-gray-900">
                                    {item.formatted_bill_no || item.bill_no || ""}
                                </td>

                                <td className="p-2 text-gray-700">
                                    {formatSalesValue(item.DiscountAmt)}
                                </td>

                                <td className="p-2 font-medium text-gray-900">
                                    {formatSalesValue(item.Subtotal)}
                                </td>

                                <td className="p-2 text-gray-700">
                                    {formatSalesValue(item.VAT)}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {item.PaymentMode === "Split" ? (
                                        <SplitTotal item={item} />
                                    ) : (
                                        formatSalesValue(item.Total)
                                    )}
                                </td>

                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {item.PaymentMode}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                    {isOrder && displayOrders.length > 0 && (
                        <tfoot className="sticky bottom-0 bg-gray-100">
                            <tr className="border-t border-gray-200">
                                <td className="p-2 font-semibold text-gray-900">
                                    Count: {displayOrders.length}
                                </td>

                                <td>
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(displayOrders, (i) => i.DiscountAmt)
                                    )}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(displayOrders, (i) => i.Subtotal)
                                    )}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(displayOrders, (i) => i.VAT)
                                    )}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(displayOrders, (i) => i.Total)
                                    )}
                                </td>

                                <td></td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
        </div>
    );
};

export default SalesVATTable;